









































import { Vue, Component, Prop } from 'vue-property-decorator';

import { ADJUSTMENT_SELECT } from '@/const/options';
import { ADJUSTMENT_TYPE } from '@/const/types/adjustment';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { IInventory } from '@/pages/campaign/adset/editingTypes';

import Select from '@/components/ElementComponent/Select/index.vue';
import NumberInput from '@/components/ElementComponent/Input/NumberInput.vue';
import PriceBrief from '@/components/ElementComponent/Brief/PriceBrief.vue';

@Component<AdsetTableOfPrice>({
    name: 'AdsetTableOfPrice',
    components: {
        Select,
        NumberInput,
        PriceBrief
    },
})
export default class AdsetTableOfPrice extends Vue {
    @Prop({ type: Array, required: true }) private value!: IInventory[];
    get targets() { return this.value}
    set targets(v: IInventory[]) { this.$emit('input', v)}

    private compTerms = compTerms;

    private ADJUSTMENT_TYPE = ADJUSTMENT_TYPE;
    private adjustmentOptions = ADJUSTMENT_SELECT;

    private typeToApply: ADJUSTMENT_TYPE | null = null;
    private priceToApply: number = 0;
    private priceSelected: IInventory[] = [];

    private priceRowSelectedHandler(val: IInventory[]) {this.priceSelected = val}
    private setPriceToSelected() {
        const t = this.typeToApply;
        const v = this.priceToApply;
        this.priceSelected.forEach((item: IInventory) => {
            (t !== null) && (item.price.type = t);
            item.price.value = v
        });
    }
}
